// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

export default class StyleGuideSnippet extends WebComponent {
	didMount() {

		function insertAfter(el, referenceNode) {
			referenceNode.parentNode.insertBefore(el, referenceNode.nextSibling);
		}

		function htmlEntities(str) {
			return String(str)
					.replace('StyleGuideSnippet','')
					.replace(/data-is="\s*?"/,'')            // remove data-is added attribute
					.replace(/data-web-component="\s*?"/,'') // remove dynamically added attribute
					.replace(/&/g, '&amp;')
					.replace(/</g, '&lt;')
					.replace(/>/g, '&gt;')
					.replace(/"/g, '&quot;')
					.replace(/'/g,'&apos')
		}

		// create
		let snippetContainer = document.createElement('pre');
		//let hr = document.createElement('hr');

		// style
		snippetContainer.setAttribute( "style",
				"font-size: 14px; " +
				"background: #f1f3f5; " +
				"padding: 2.4rem;" +
				"box-shadow: inset 0px 0px 24px 2px rgba(0,0,0,0.12);" +
				"margin: 4rem 0;" +
				"white-space: pre"
		);
		// fill up
		snippetContainer.innerHTML = htmlEntities(this.element.outerHTML);

		// insert after
		insertAfter(snippetContainer, this.element);
		//insertAfter(hr, snippetContainer);
	}
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/StyleGuideSnippet.js